const NewsList2024 = [

    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/best_thesis_award_Dr_Uthradevi.pdf",
        title: "Congratulations to Dr. Uthradevi Kannan",
        desc: "Dr. Uthradevi Kannan received the best Ph.D. Thesis Award and First Dean's Prize for her thesis titled 'A resource-efficient and waste-free point of use disinfection system' at the fifth convocation held on 22nd February 2024 (Thesis supervisor: Dr. Shihabudheen M. Maliyekkal, Department of Civil and Environmental Engineering, IIT Tirupati)."
    },

    {
        dt: "June",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/VivekGupta.png",
        title: "Congratulations to Mr. Vivek Gupta",
        desc: "Mr. Vivek Gupta, Ph.D. Research Scholar from the Department of Chemical Engineering got the Honourable Mention Graduate Student Poster Competition Award at the 26th Food Innovation Asia Conference 2024 at BITEC, Bangkok, Thailand."
    },
    {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/BPA_Naga_Jyothi.png",
        title: "Congratulations to Ms. M.S.V. Naga Jyothi",
        desc: "Ms. M.S.V. Naga Jyothi, Ph.D. Scholar (Civil & Environmental Engineering) received the 'Best Presentation Award' for the Oral Presentation at the '14th International Conference on Environmental Engineering and Applications (ICEEA 2024) on 24-26 April 2024 at 'Universidad Politécnica de Madrid', Spain."
    },

    {
        dt: "April",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Mamilla Ravi Sankar",
        desc: "Prof. Mamilla Ravi Sankar, Professor (Mechanical Engineering) nominated as Associate Editor, Journal of Manufacturing Processes (Elsevier). This is one of the top Manufacturing Journals."
    },

    {
        dt: "March",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Based on his teams research contributions in the areas of roadway noise and modeling, has been appointed an 'International Member of the USNAE Transportation Research Board Standing Committee' on Transportation-Related Noise and Vibration: 2024-27."
    },
    {
        dt: "March",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Elected as 'Fellow of the Institution of Engineers(India)', March 2024."
    },

    {
        dt: "March",
        my: "",
        link: "https://www.ismarti.org/",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Appointed as 'iSMARTi Vice President of South Asia'. ISMARTi: International Society for Maintenance And Rehabilitation of Transport infrastructures"
    },
    {
        dt: "March",
        my: "",
        link: "https://www.ismarti.org/",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Appointed as 'iSMARTi Vice President of South Asia'. ISMARTi: International Society for Maintenance And Rehabilitation of Transport infrastructures"
    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Dr.Ajay_Chandran_Menon_Memorial_Award.pdf",
        title: "Congratulations to Dr. Ajay Kumar",
        desc: "Dr. Ajay Kumar, Assistant Professor (Mechanical Engineering Department) received the 'Chandran Menon Memorial Award' for Applied Research & Innovative Technology for 2022 - 23. The award was given in the 72nd INDIAN FOUNDRY CONGRESS(IFC) on 2nd February 2024, at BIEC, Bengaluru, Karnataka."
    },
    {
        dt: "January",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Vikas_Kumar_BPA.pdf",
        title: "Congratulations to Mr. Vikas Kumar Sahu",
        desc: "Mr. Vikas Kumar Sahu, Ph.D. Scholar (Physics Department) received “Best Poster Presentation Award” from International Conference on Highly Frustrated Magnetism 2024 organized by IIT Madras from 7 - 13 January 2024."
    }


];


export default NewsList2024;
